<script lang="ts" setup>
import TruckDriverBlock from "@/views/trips/edit/blocks/TruckDriverBlock.vue";
import type { TripRoute } from "@/views/trips/edit/trip";
import { computed, onMounted, ref } from "vue";
import { TruckType } from "@/data/truck";
import TruckLink from "@/components/links/TruckLink.vue";
import type { DriverDto } from "@/api/users/dto/driver.dto";
import type { ContactPersonDto, TruckDriverDto } from "@/api/trucks/dto/truck.dto";
import { useTrip } from "@/composables";

const { getRouteDriver, getRouteContactPerson } = useTrip();

const props = defineProps<{
  route: TripRoute;
}>();

const driver = ref<DriverDto | TruckDriverDto | null>(null);
const contactPerson = ref<ContactPersonDto | null>(null);

const truckType = computed(() => {
  return TruckType.find((item) => item.id === props.route.truck?.type)?.name;
});

const truckTrailer = computed(() => {
  return props.route.truck?.trailer;
});

const truckId = computed(() => {
  return props.route.truck?.id;
});

const truckNumber = computed(() => {
  return props.route.truck?.number || "";
});

onMounted(async () => {
  driver.value = await getRouteDriver(props.route.driverId, props.route.truck);

  if (driver.value) {
    contactPerson.value = await getRouteContactPerson(driver.value.contactPersonId, props.route.truck);
  }
});
</script>

<template>
  <div>
    <div class="d-flex align-center justify-space-between mb-3">
      <div class="text-grey-darken-3 font-weight-medium text-subtitle-1">Dispatching contacts</div>
      <div class="d-flex flex-wrap">
        <truck-link :truck-id="truckId" :truck-number="truckNumber" class="mr-2" />

        <span v-if="truckTrailer" class="text-grey-darken-2" data-qa="dispatching-contacts-freights-summary">
          {{ truckType }}, {{ truckTrailer.length }}″ x {{ truckTrailer.height }}″ x {{ truckTrailer.width }}″,
          {{ truckTrailer.payload }} lbs
        </span>
      </div>
    </div>
    <div>
      <v-row>
        <v-col v-if="driver" lg="3" md="4" sm="6" xl="3" xs="12" xxl="3">
          <truck-driver-block :driver="driver" />
        </v-col>

        <v-col v-if="contactPerson" lg="3" md="4" sm="6" xl="3" xs="12" xxl="3">
          <truck-driver-block :driver="contactPerson" is-financially-responsible />
        </v-col>
      </v-row>
    </div>
  </div>
</template>
